import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo-mobile.png'

function Nav() {

    return (
        <section>
            <nav className="navbar navbar-dark bg-primary position-sticky top-0" style={{ overFlowX: 'hidden' }}>
                <div className="container">
                    <Link to='/' className="navbar-brand " > <img className='img-fluid nav-logo bg-black' src={logo} alt="logo" /></Link>

                    <Link to='/'><button className='logoutBtn fw-normal' >Home</button></Link>
                </div>
            </nav>

        </section>
    );
}


export default Nav;
